import { Inject, Injectable } from '@angular/core';
import { CHANNEL_REPOSITORY, ChannelsRepository } from '@core/repositories/channels.repository';
import { Channel } from '@shared/interfaces/channel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChannelsService {
  constructor(
    @Inject(CHANNEL_REPOSITORY) protected repository: ChannelsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(channel: Channel): Observable<any> {
    return this.repository.add(channel);
  }

  edit(channel: Channel): Observable<any> {
    return this.repository.edit(channel);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
